/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerEjectFilled = createReactComponent("filled", "player-eject-filled", "IconPlayerEjectFilled", [["path", { "d": "M11.247 3.341l-7 8c-.565 .647 -.106 1.659 .753 1.659h14c.86 0 1.318 -1.012 .753 -1.659l-7 -8a1 1 0 0 0 -1.506 0z", "key": "svg-0" }], ["path", { "d": "M18 15h-12a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-1" }]]);

export { IconPlayerEjectFilled as default };
//# sourceMappingURL=IconPlayerEjectFilled.mjs.map
